import { Segment, Table, Header } from 'semantic-ui-react';
import { useCallback } from 'react';
import { useRefreshQuotesStatus, useRequestQuotesOptIn, useRefreshOptOutStatus, useRefreshQuotes } from '@app/sdk';

type PayDownPlanQuotesOptOutProps = {
    accountId: string;
  }

export default function PayDownPlanQuotesOptOut(props: PayDownPlanQuotesOptOutProps) {
    const refreshOptOutStatus = useRefreshOptOutStatus();
    const refreshQuotesStatus = useRefreshQuotesStatus();
    const refreshQuotes = useRefreshQuotes();
    
    const { mutate: requestQuoteOptIn, isPending: isEditPending } = useRequestQuotesOptIn();

    const quoteOptIn = useCallback(async () => {
        await requestQuoteOptIn({accountId: props.accountId});
        setTimeout(() => {
            refreshOptOutStatus();
            refreshQuotesStatus();
            refreshQuotes();
        }, 2000);
    }, [props.accountId, requestQuoteOptIn]);

    return (
        <>
            <button
                type="button"
                className="ui button blue"
                onClick={() => quoteOptIn()}
                disabled={isEditPending}>
                <span>Opt In</span>
            </button>
        </>
    )
}